import React from 'react';
import styled from 'styled-components';

const GreetingsContainer = styled.div`
  padding: 40px 20px;
  max-width: 960px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const PastorImage = styled.img`
  width: 300px;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const MessageContainer = styled.div`
  flex: 1;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: #2c5aa0;
  margin-bottom: 20px;
  text-align: center;
`;

const Content = styled.div`
  font-size: 1.1rem;
  line-height: 1.8;
  color: #333;

  p {
    margin-bottom: 20px;
  }
`;

const Greetings: React.FC = () => {
  return (
    <>
      <Title>인사말</Title>
      <GreetingsContainer>
        <PastorImage src="/senior_pastor.jpg" alt="Senior Pastor" />
        <MessageContainer>
          <Content>
            <p>
              하나님의 부르심은 언제나, 어디에서나 가장 큰 축복입니다.
              <br />
              얼바인중앙침례교회 역시 하나님의 부르심을 따라 하나님의 때에 세워진 교회입니다.
            </p>
            <p>
              교회란 하나님께서 자기 백성을 축복하시기 위해,
              <br />
              하나님의 영광을 나타내고 그 영광을 나누시기 위해 죄인을 불러내어 만드신 공동체입니다.
              <br />
              그리고 교회는 무엇보다도 하나님의 언약과 생명의 말씀이 충만한 곳입니다.
            </p>
            <p>
              우리의 연약함, 슬픔, 곤고함과 영혼의 갈증을 다 아시는 하나님께서
              <br />
              하나님의 뜻과 계획 가운데 세우신 얼바인중앙침례교회로 부르시고 초청하실 때에
              <br />
              망설이지 마시고 모두 다 오셔서
              <br />
              하나님께서 교회를 통해 주시는 놀라운 영생의 축복과 말씀의 안식과 기쁨을 누리시는
              <br />
              복된 인생이 되시기를 바랍니다.
            </p>
          </Content>.
        </MessageContainer>
      </GreetingsContainer>
    </>
  );
};

export default Greetings;